import { getAnalyticsUser, identify } from 'src/analytics/Analytics';
import { QuizRecord } from 'src/types/Quiz';
import { setAuthCookies } from './auth';

type GetQuizSearchParams = {
    quizToken: string;
    quizVersion: string;
    subscriptionId?: string;
    quizSubVersion?: string;
    quizResumeSource?: string;
};

function getQuizSearchParams({
    quizVersion,
    quizToken,
    subscriptionId,
    quizSubVersion,
    quizResumeSource,
}: GetQuizSearchParams) {
    const params = new URLSearchParams({
        quiz_version: quizVersion,
        quiz_token: quizToken,
    });

    if (subscriptionId) {
        params.append('subscription_id', subscriptionId);
    }

    if (quizSubVersion) {
        params.append('quiz_sub_version', quizSubVersion);
    }

    if (quizResumeSource) {
        params.append('quiz_resume_source', quizResumeSource);
    }

    return params;
}

type GetQuizBaseUrlParams = {
    quizFlow: string;
    quizType: string;
    quizToken: string;
    quizVersion: string;
    subscriptionId?: string;
    quizCoBrand?: string;
    quizSubVersion?: string;
    quizResumeSource?: string;
};

export function getQuizBaseUrl({
    quizFlow,
    quizType,
    quizToken,
    quizVersion,
    subscriptionId,
    quizSubVersion,
    quizResumeSource,
}: GetQuizBaseUrlParams) {
    const params = getQuizSearchParams({
        quizVersion,
        quizToken,
        subscriptionId,
        quizSubVersion,
        quizResumeSource,
    });
    const quizBaseUrl = `/${quizFlow}/${quizType}?${params.toString()}`;

    return quizBaseUrl;
}

export const checkLoginFromQuizResponse = (response: QuizRecord) => {
    if (response.accessToken && response.uuid) {
        setAuthCookies(response.accessToken, response.uuid);
    }
};

export const checkIdentifyFromQuizResponse = (response: QuizRecord) => {
    getAnalyticsUser().then((user) => {
        if (
            response.id &&
            response.uuid &&
            user.id() !== response.id.toString()
        ) {
            identify(response.id.toString(), { uuid: response.uuid });
        }
    });
};
